export const DOMAIN_PHONE_NUMBERS = {
  lt: ["+370", "+371", "+372"],
  lv: ["+371", "+372", "+370"],
  ee: ["+372", "+371", "+370"],
};
